module.exports = __webpack_public_path__ + "fonts/KFOkCnqEu92Fr1MmgVxMIzIFKw.d9071d3b.woff2";